import { formatPhoneNumberIntl } from "react-phone-number-input";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { DateRange } from "react-day-picker";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function dateToString(d: Date | null | undefined): string {
  if (!d) return "-";
  return d.toDateString();
}

export function dateFormatedToString(d: Date | null | undefined): string {
  if (!d) return "-";
  return d.toLocaleDateString();
}

export function formatPhoneNumber(value: string | null | undefined) {
  return formatPhoneNumberIntl(value as unknown as string);
}

export function JSONParseSafe<T>(str: string): T | undefined {
  try {
    return JSON.parse(str);
  } catch (e) {
    console.error("Error parsing JSON", e);
    return undefined;
  }
}

export function getDateValue(k: string | undefined): DateRange {
  if (!k) return { from: undefined, to: undefined };
  const [fromStr, toStr] = k.split(" - ");
  const result: DateRange = {
    from: fromStr ? new Date(+fromStr) : undefined,
    to: toStr ? new Date(+toStr) : undefined,
  };

  return result;
}

export function sortDates(aDate: string, bDate: string): number {
  const a = getDateValue(aDate);
  const b = getDateValue(bDate);

  // Handle cases where from dates are undefined
  if (!a.from && !b.from) return 0; // Both are undefined, considered equal
  if (!a.from) return 1; // a.from is undefined, push it to the end
  if (!b.from) return -1; // b.from is undefined, push it to the end

  // Compare start dates
  if (a.from.getTime() - b.from.getTime() !== 0) {
    return a.from.getTime() - b.from.getTime(); // Sort by start date
  }

  // Handle cases where to dates are undefined
  if (!a.to && !b.to) return 0; // Both are undefined, considered equal
  if (!a.to) return 1; // a.to is undefined, push it to the to
  if (!b.to) return -1; // b.to is undefined, push it to the to

  // Compare to dates
  return a.to.getTime() - b.to.getTime(); // Sort by to date if start dates are the same
}

export function getJsonSync(url: string): object {
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, false); // `false` makes the request synchronous
  xhr.setRequestHeader("Accept", "application/json");
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.send();

  if (xhr.status === 200) {
    try {
      return JSON.parse(xhr.responseText);
    } catch (error) {
      console.error(`Error parsing JSON file ${url}:`, error);
      throw error;
    }
  } else {
    throw new Error(`Request failed with status ${xhr.status}`);
  }
}
